import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const customerListKey = () => ['customerList'];
export const customerListFn = () => apiClient.get(`${APP_API_URL}customer/list`);

const customerListSelect = ({ data }) => {
  return {
    customers: data.list,
    currentCustomerId: +data.selected_customer_id,
  };
};

export const useCustomerListQuery = () => {
  return useQuery({
    queryKey: customerListKey(),
    queryFn: customerListFn,
    select: customerListSelect,
  });
};
